import * as React from 'react';
import { useEffect } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { isAndroid, isIOS } from 'react-device-detect';
import DetectPlatform from './DetectPlatform';
import { Box, IconButton, Typography, Link, Divider } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import YouTubeIcon from '@mui/icons-material/YouTube';
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';

export default function ScrollDialog() {
  const [open, setOpen] = React.useState(false);
  const [scroll, setScroll] = React.useState('paper');
  const [device, setDevice] = React.useState('');
  
  useEffect(() => {
    if (isIOS) {
      setDevice('How to install App for iOS');
    } else if (isAndroid) {
      setDevice('How to install App for Android');
    }
  }, []);
  
  const handleClickOpen = (scrollType) => () => {
    setOpen(true);
    setScroll(scrollType);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const descriptionElementRef = React.useRef(null);
  React.useEffect(() => {
    if (open) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  }, [open]);

  return (
    <div>
      <Button onClick={handleClickOpen('paper')}>{device}</Button>
      
      <Dialog
        open={open}
        onClose={handleClose}
        scroll={scroll}
        maxWidth="xs"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 3,
            boxShadow: '0 8px 32px rgba(0,0,0,0.2)',
            overflow: 'hidden',
            margin: { xs: 2, sm: 4 },
            width: { xs: 'calc(100% - 32px)', sm: 'auto' },
            maxWidth: { xs: 'calc(100% - 32px)', sm: '480px' }
          }
        }}
      >
        <Box sx={{ 
          background: 'linear-gradient(135deg, #3d6e75 0%, #2e5a60 100%)',
          color: 'white',
          py: 2,
          px: 3,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between'
        }}>
          <DialogTitle sx={{ 
            p: 0, 
            fontWeight: 600,
            color: 'white',
            fontSize: { xs: '1.25rem', sm: '1.5rem' }
          }}>
            Install on Your Phone
          </DialogTitle>
          <IconButton
            onClick={handleClose}
            aria-label="close"
            sx={{
              color: 'white',
              p: 1,
              '&:hover': {
                backgroundColor: 'rgba(255,255,255,0.15)'
              }
            }}
          >
            <CloseIcon />
          </IconButton>
        </Box>
        
        <DialogContent
          sx={{
            p: 0,
            overflowX: 'hidden',
            '&::-webkit-scrollbar': {
              width: '8px',
            },
            '&::-webkit-scrollbar-thumb': {
              backgroundColor: '#bdbdbd',
              borderRadius: '4px',
            }
          }}
        >
          <Box
            ref={descriptionElementRef}
            tabIndex={-1}
            sx={{
              width: '100%',
              overflowX: 'hidden'
            }}
          >
            <DetectPlatform />
            
            <Divider sx={{ my: 1.5, mx: 2 }} />
            
            <Box sx={{ px: 3, pb: 3, pt: 1 }}>
              <Typography variant="body2" sx={{ color: 'text.secondary', mb: 1.5 }}>
                Need more help? Watch our step-by-step video tutorial:
              </Typography>
              
              <Button
                variant="outlined"
                size="medium"
                component="a"
                href="https://www.youtube.com/shorts/J93MHSRM_kg"
                target="_blank"
                rel="noreferrer"
                startIcon={<YouTubeIcon sx={{ color: '#FF0000' }} />}
                endIcon={<PlayCircleOutlineIcon />}
                sx={{
                  borderColor: 'rgba(0,0,0,0.15)',
                  color: '#3d6e75',
                  textTransform: 'none',
                  fontWeight: '500',
                  '&:hover': {
                    borderColor: 'rgba(0,0,0,0.3)',
                    backgroundColor: 'rgba(61, 110, 117, 0.04)'
                  }
                }}
              >
                Watch Installation Video
              </Button>
            </Box>
          </Box>
        </DialogContent>
        
        <Box sx={{ 
          p: 2, 
          display: 'flex', 
          justifyContent: 'flex-end',
          borderTop: '1px solid rgba(0,0,0,0.1)' 
        }}>
          <Button 
            onClick={handleClose}
            variant="contained"
            disableElevation
            sx={{
              backgroundColor: '#3d6e75',
              color: 'white',
              textTransform: 'none',
              fontWeight: 'bold',
              px: 3,
              borderRadius: 2,
              '&:hover': {
                backgroundColor: '#2e5a60'
              }
            }}
          >
            I understand
          </Button>
        </Box>
      </Dialog>
    </div>
  );
}
